import React, { Component } from "react";
import FaPhone from "react-icons/lib/fa/phone";
import MdMail from "react-icons/lib/md/mail";
import MdPlace from "react-icons/lib/md/place";
import { connect } from "react-redux";
import { Col } from "Components";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "Bireysel"
    };
  }
  render = () => (
    <div className="header">
      <div className="container row">
        <Col l={7} m={12} s={12}>
          <a className="top_menu_link">
            <FaPhone className="icon" /> {this.props.config.phone}
          </a>
          <a className="top_menu_link">
            <MdMail className="icon" /> {this.props.config.email}
          </a>
          <a className="top_menu_link">
            <MdPlace className="icon" />
            {this.props.config.short_address}
          </a>
        </Col>
        <Col l={5} m={12}>
          <div
            className={`${
              this.props.screen.mq === "l" ? "" : "m"
            } orange_layer `}
          />
          <nav className={`${this.props.screen.mq !== "l" ? "m" : ""} `}>
            <a>İnternet Şubesi</a>
            <button
              onClick={() => this.setState({ filter: "Bireysel" })}
              className={this.state.filter === "Bireysel" ? "active" : null}
            >
              <span>Bireysel</span>
            </button>
            <button
              onClick={() => this.setState({ filter: "Ticari" })}
              className={this.state.filter === "Ticari" ? "active" : null}
            >
              <span>Ticari</span>
            </button>
          </nav>
        </Col>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  config: state.config ? state.config.data : {},
  screen: state.screen
});
export default connect(mapStateToProps)(Header);
